const LoaderTipo = {
  data: {
    SHOW_LOADER: 900
  }
};

export default LoaderTipo;